import { Outlet, Link, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/use-auth'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { Briefcase, Users, GitPullRequest, LogOut } from 'lucide-react'
import logoFarol from '@/assets/faroledu.jpg'

export default function AdminLayout() {
  const { signOut } = useAuth()
  const location = useLocation()

  const navItems = [
    { name: 'Vagas (Jobs)', href: '/admin/jobs', icon: Briefcase },
    { name: 'Educadores', href: '/admin/educators', icon: Users },
    { name: 'Matches', href: '/admin/matches', icon: GitPullRequest },
  ]

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-gray-200 hidden md:flex flex-col">
        <div className="p-6 border-b border-gray-100">
          <Link to="/" className="flex items-center gap-2">
            <img
              src={logoFarol}
              alt="Farol Edu"
              className="h-8 w-auto object-contain"
            />
            <span className="font-bold text-lg text-brand-navy">
              Farol Edu Admin
            </span>
          </Link>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors',
                location.pathname.startsWith(item.href)
                  ? 'bg-brand-emerald/10 text-brand-emerald'
                  : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900',
              )}
            >
              <item.icon className="w-5 h-5" />
              {item.name}
            </Link>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-100">
          <Button
            variant="ghost"
            className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50"
            onClick={() => signOut()}
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sair
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-6 md:hidden">
          <Link to="/admin" className="font-bold text-brand-navy">
            Farol Edu Admin
          </Link>
          <Button size="sm" variant="outline" onClick={() => signOut()}>
            Sair
          </Button>
        </header>

        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
